var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 39H41V19.2481C40.8949 8.56589 31.7487 0 20.5 0C9.14615 0 0 8.76744 0 19.5504C0 30.2326 9.25128 39 20.5 39Z",
    fill: "#297687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19417 19.8481C9.19417 19.466 9.34432 19.0995 9.6116 18.8293C9.87888 18.5591 10.2414 18.4073 10.6194 18.4073L27.1318 18.4073L21.012 12.2236C20.8795 12.0896 20.7743 11.9306 20.7026 11.7556C20.6309 11.5805 20.594 11.3929 20.594 11.2035C20.594 11.0141 20.6309 10.8265 20.7026 10.6514C20.7743 10.4764 20.8795 10.3174 21.012 10.1834C21.1445 10.0495 21.3018 9.94321 21.4749 9.87072C21.6481 9.79822 21.8336 9.76091 22.021 9.76091C22.2084 9.76091 22.394 9.79822 22.5671 9.87072C22.7402 9.94321 22.8976 10.0495 23.0301 10.1834L31.5813 18.828C31.714 18.9619 31.8193 19.1209 31.8912 19.2959C31.963 19.4709 32 19.6586 32 19.8481C32 20.0376 31.963 20.2253 31.8912 20.4003C31.8193 20.5753 31.714 20.7343 31.5813 20.8682L23.0301 29.5128C22.7624 29.7833 22.3995 29.9353 22.021 29.9353C21.6425 29.9353 21.2796 29.7833 21.012 29.5128C20.7444 29.2422 20.594 28.8753 20.594 28.4927C20.594 28.1101 20.7444 27.7432 21.012 27.4726L27.1318 21.2889L10.6194 21.2889C10.2414 21.2889 9.87888 21.1371 9.6116 20.8669C9.34432 20.5967 9.19417 20.2302 9.19417 19.8481Z",
    fill: "#8ED6E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkArrow);
export default __webpack_public_path__ + "static/media/icon_link-arrow.5fdb7049c6a8f145e1e77ac1a5e3ecb5.svg";
export { ForwardRef as ReactComponent };